<template>
  <div>
    <PersonalAreaNavBar
      :title="$t('messages.myMessages')"
      backurl="personal-area-mainmenu"
    />
    <div class="pam-content lang-dir">
      <div
        style="padding: 0px 15px; height: 100%; padding-bottom: 15px"
        :style="{ 'padding-top': $store.state.hasInternet ? '15px' : '0px' }"
      >
        <PersonalAreaMessages :allMessages="true" />
      </div>
    </div>
  </div>
</template>

<script>
import PersonalAreaMessages from "../personalArea/PersonalAreaMessages.vue";
import PersonalAreaNavBar from "./PersonalAreaNavBar.vue";
export default {
  components: {
    PersonalAreaMessages,
    PersonalAreaNavBar,
  },
};
</script>

<style lang="scss" scoped>
.pam-content {
  // padding-top: 15px;
  height: calc(100% - 56px);
}
.spacer {
  padding: 15px;
}
</style>
